var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6219 5.05597L5.72187 17.337C4.97487 17.592 4.75487 18.542 5.31287 19.1L28.8979 42.685C29.4559 43.243 30.4059 43.023 30.6609 42.276L42.9419 6.37597C43.2229 5.55897 42.4399 4.77597 41.6219 5.05597Z",
    fill: "#1F6CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1055 30.8927L28.8975 42.6847C29.4555 43.2427 30.4055 43.0227 30.6605 42.2757L42.9415 6.37569C43.0825 5.96769 42.9565 5.56769 42.6935 5.30469L17.1055 30.8927Z",
    fill: "#0A57EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.99805L13 26.787V33.998C13 34.55 13.448 34.998 14 34.998H21.211L38 9.99805Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.c94538801e37a94239c9ca90da607843.svg";
export { ForwardRef as ReactComponent };